import { Box, styled } from "@mui/system";
import { Form, Formik } from "formik";
// import { Autocomplete } from "formik-mui";

import CustomAutocomplete from "../../components/custom/Autocomplete";

import PrimaryButton from "../../components/custom/PrimaryButton";

import TextField from "../../components/custom/TextField";
import UploadFile from "../../components/custom/UploadFile";
import * as Yup from "yup";
import { FormControl, Stack, Grid } from "@mui/material";
import { useQuery } from "react-query";
import { getDistributors } from "../../services/distributorService";
import { useEffect } from "react";
import bookUpload from "../../assets/icons/bookUpload.png";
import { useNavigate } from "react-router-dom";

const UploadFileContainer = styled(Stack)`
  width: 50%;
  justify-content: center;
  margin: auto;
  margin-top: ${(props) => props.theme.spacing(10)};
`;

const BookForm = ({
  edit = false,
  formikRef,
  disabledDistributors = false,
  onSubmit = () => {},
  initialValues = {
    title: "",
    author: "",
    publishers: "",
    description: "",
    bookCategory: "",
    year: null,
    isbn: "",
    price: 0.0,
    language: "",
    ages: "",
    copyright: "",
    keywords: "",
    origin: "",
    devices: "",
    coverfile: null,
    bookfile: null,
    distributors: [],
  },
}) => {
  const navigate = useNavigate();

  const { data: allDistributors } = useQuery(
    "AllDistributors",
    getDistributors
  );

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Field is required"),
    publishers: Yup.string(),
    description: Yup.string(),
    bookCategory: Yup.string(),
    year: Yup.number()
      .positive()
      .nullable()
      .notRequired()
      .typeError("Year must be positive number"),
    isbn: Yup.string(),
    price: Yup.number().positive().required(),
    language: Yup.string(),
    ages: Yup.string(),
    copyright: Yup.string(),
    keywords: Yup.string(),
    origin: Yup.string(),
    devices: Yup.string(),
    // coverfile: Yup.mixed().required(),
    // bookfile: Yup.mixed().required(),
    distributors: Yup.array().min(1, "Must have at least one distributor"),
  });
  useEffect(() => {
    return () => {
      formikRef?.current?.resetForm();
    };
  }, []);

  return (
    <Box sx={{ mb: 10 }}>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {({
          submitForm,
          values,
          setFieldValue,
          touched,
          errors,
          dirty,
          resetForm,
        }) => (
          <Form>
            {edit && (
              <UploadFileContainer
                direction="row"
                justifyContent="space-around"
              >
                <UploadFile
                  title="Bookfile"
                  name="bookfile"
                  accept="application/pdf"
                  altImg={bookUpload}
                />
                <UploadFile
                  title="Coverfile"
                  name="coverfile"
                  accept="image/png, image/jpeg"
                />
              </UploadFileContainer>
            )}

            <TextField label={"Title"} name="title" />
            <TextField label={"Author"} name="author" />
            <TextField label={"Category"} name="bookCategory" />
            <TextField label={"Publisher"} name="publishers" />

            <TextField
              label={"Description"}
              name="description"
              multiline
              minRows={10}
            />
            {/* Book category */}
            <TextField label={"Year"} name="year" />
            <TextField label={"ISBN"} name="isbn" />
            <TextField
              label={"Price"}
              name="price"
              type="number"
              onWheel={() => document.activeElement.blur()}
              InputProps={{
                inputProps: { min: 0.0, step: 0.01 },
              }}
            />
            <TextField label={"Languages"} name="language" />
            <TextField label={"Ages"} name="ages" />
            <TextField label={"Copyright"} name="copyright" />
            <TextField label={"Keywords"} name="keywords" />
            <TextField label={"Origin"} name="origin" />
            <TextField label={"Devices"} name="devices" />
            {initialValues && (
              <FormControl>
                <CustomAutocomplete
                  disabled={disabledDistributors}
                  name="distributors"
                  label="Distributors"
                  multiple={true}
                  getOptionLabel={(option) => option?.alias || ""}
                  options={allDistributors || []}
                />
              </FormControl>
            )}

            <Grid container justifyContent="left">
              <PrimaryButton
                disabled={!dirty}
                onClick={submitForm}
                sx={{ my: { xs: 5, md: 10 }, mr: { xs: 1, md: 8 } }}
              >
                Save & Publish
              </PrimaryButton>
              <PrimaryButton
                onClick={() => navigate("/books")}
                sx={{ my: { xs: 5, md: 10 } }}
              >
                Cancel
              </PrimaryButton>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default BookForm;
